<!--
<SelectWithValidation
  rules="required"
  type="text"
  label="지점명"
  name="form.company2.name"
  size="sm"
  class="col-6 d-inline-block"
  v-model="form.company2.seq"
  :options="companyOption2"
  @dataChanged="dataChanged2"
  description=""
  placeholder="지점를 입력해주세요."
/>
-->
<template>
  <ValidationProvider
    ref="validator"
    :vid="vid"
    :name="($attrs.label ? $attrs.label : $attrs.name)"
    :rules="rules"
    v-slot="{ valid, errors }"
  >
    <b-form-group v-bind="$attrs">
      <b-form-select
        v-bind="$attrs"
        :state="errors[0] ? false : (valid ? true : null)"
        v-model="innerValue"
      >
        <slot/>
      </b-form-select>
      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>


<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      //console.log(newVal);
      //console.log(this.$refs.validator);
      this.$emit("dataChanged", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
